/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._flex_ttjxc_157 {
  display: flex;
}

._justify-content-space-between_ttjxc_161 {
  justify-content: space-between;
}

._tabular-nums_ttjxc_165 {
  font-variant-numeric: tabular-nums;
}

@keyframes _show_ttjxc_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Text styles */
._TotalsSection_ttjxc_178 ._item_ttjxc_178 ._count_ttjxc_178, ._content_ttjxc_178 ._header_ttjxc_178 ._title_ttjxc_178 h3 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  color: #1a1818;
}

._TotalsSection_ttjxc_178 ._item_ttjxc_178 ._type_ttjxc_188 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.214;
  color: #1a1818;
}

._content_ttjxc_178 ._header_ttjxc_178 ._title_ttjxc_178 h4 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  color: #1a1818;
}

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

/* ASPIRE UI THEME **/
/* ASPIRE IQ THEME */

._flex_ttjxc_157 {
  display: flex;
}

._justify-content-space-between_ttjxc_161 {
  justify-content: space-between;
}

._tabular-nums_ttjxc_165 {
  font-variant-numeric: tabular-nums;
}

@keyframes _show_ttjxc_1 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Text styles */
._TotalsSection_ttjxc_178 ._item_ttjxc_178 ._count_ttjxc_178, ._content_ttjxc_178 ._header_ttjxc_178 ._title_ttjxc_178 h3 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  color: #1a1818;
}

._TotalsSection_ttjxc_178 ._item_ttjxc_178 ._type_ttjxc_188 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.214;
  color: #1a1818;
}

._content_ttjxc_178 ._header_ttjxc_178 ._title_ttjxc_178 h4 {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  color: #1a1818;
}

._content_ttjxc_178 {
  padding: 1.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
._content_ttjxc_178 ._header_ttjxc_178 {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
._content_ttjxc_178 ._header_ttjxc_178 ._title_ttjxc_178 {
  display: flex;
  flex-direction: column;
}
._content_ttjxc_178 ._header_ttjxc_178 ._title_ttjxc_178 h3 {
  margin: 0.5rem 0 0.5rem 0.5rem;
  color: #2e426d;
}
._content_ttjxc_178 ._header_ttjxc_178 ._title_ttjxc_178 h4 {
  margin: 0 0 0.5rem 0.5rem;
  color: #8f8d91;
}
._content_ttjxc_178 ._header_ttjxc_178 ._select_ttjxc_471 {
  margin-left: auto;
}

._TotalsSection_ttjxc_178 {
  margin: 0;
  padding: 0 2.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
  background: #ffffff;
  box-shadow: 0rem 0.5rem 3.75rem rgba(46, 66, 109, 0.08);
  border-radius: 0.5rem;
}
._TotalsSection_ttjxc_178 ._totalsRow_ttjxc_486 {
  margin: 0.3125rem 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  flex-wrap: nowrap;
  width: 100%;
}
._TotalsSection_ttjxc_178 ._totalsRow_ttjxc_486._compare_ttjxc_495 {
  color: #ef5682;
}
._TotalsSection_ttjxc_178 ._item_ttjxc_178 {
  padding: 0.9375rem 0.3125rem;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
._TotalsSection_ttjxc_178 ._item_ttjxc_178._withTooltip_ttjxc_505:hover {
  background-color: #eff5f9;
  border-radius: 0.25rem;
  cursor: help;
}
._TotalsSection_ttjxc_178 ._item_ttjxc_178 ._count_ttjxc_178 {
  margin-bottom: 0.625rem;
  color: #3996e0;
}
._TotalsSection_ttjxc_178 ._item_ttjxc_178 ._count_ttjxc_178._compare_ttjxc_495 {
  color: #ef5682;
}
._TotalsSection_ttjxc_178 ._item_ttjxc_178 ._type_ttjxc_188 {
  color: #8f8d91;
}